export default "__VITE_ASSET__DAGMZUFh__"